import React, { useEffect } from 'react'
import {
  Image,
  withSitecoreContext,
  RichText,
  Link,
  isEditorActive,
  LinkField,
  LinkFieldValue,
} from '@sitecore-jss/sitecore-jss-react'

import './index.scss'
import { ColumnCardProps } from './types/ColumnCard.types'
import LazySection from '../../react-only-components/LazySection'

const ColumnCard = (props: ColumnCardProps) => {
  const isEE = props.sitecoreContext?.pageEditing
  const ColumnCardList = props?.fields?.['Column Cards']
  const isThreeColumns = props?.fields?.['Three Columns']?.value

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  return (
    <LazySection offset={0} id={props?.rendering?.uid}>
      {props?.fields && (
        <div
          className={`ColumnCard__wrapper ${
            isThreeColumns ? 'ColumnCard__wrapper--three' : ''
          }`}
        >
          {(ColumnCardList ?? []).map((item, i) => (
            <div className="ColumnCard" key={i}>
              <div className="ColumnCard_image-wrapper">
                {isEE ? null : <div className="overlay" id="overlay"></div>}

                {/* <img className="ColumnCard__img" src={item?.fields?.Image?.value?.src} alt={item?.fields?.Image?.value?.alt} /> */}
                <Image
                  loading="lazy"
                  field={item?.fields?.Image}
                  className={'image--desktop'}
                />
                {/* <Image loading="lazy" field={item?.fields?.imageMobile} className={'image--mobile'} /> */}
                <Image
                  loading="lazy"
                  field={
                    item?.fields?.imageMobile ?
                    ((item?.fields?.imageMobile?.value?.length as number > 0)
                      ? item?.fields?.imageMobile
                      : item?.fields?.Image) : undefined
                  }
                  className={'image--mobile'}
                />
              </div>
              <div className="ColumnCard_content">
                <RichText
                  field={item?.fields?.Eyebrow}
                  className="ColumnCard__eyebrow-text"
                  tag="p"
                  // encode={false}
                />
                <RichText
                  field={item?.fields?.Title}
                  className="ColumnCard__title"
                  tag="h3"
                  // encode={false}
                />
                {/* <p className="ColumnCard__eyebrow-text">{item?.fields?.Eyebrow?.value}</p> */}
                {/* <h3 className="ColumnCard__title">{item?.fields?.Title?.value}</h3> */}
                <div className="cta-wrapper">
                  <div
                    className="cta cta-primary cta-primary-black"
                    style={{
                      width: '102%',
                    }}
                  >
                    {isEditorActive() ? (
                      <Link field={item?.fields?.Link as LinkField} />
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <Link
                          field={item?.fields?.Link?.value as LinkFieldValue}
                          className="cta-with-arrow"
                        />
                        <span
                          className="cta-with-arrow__text"
                          style={{
                            marginLeft: '2%',
                          }}
                        >
                          <pfe-icon
                            icon="cnh-arrow-forward"
                            size={'24'}
                            color={'base'}
                            className="cta-with-arrow__icon PFElement"
                          />
                        </span>
                      </div>
                    )}
                  </div>
                  {item?.fields?.['Secondary Link']?.value.href ? (
                    <div className="cta cta-primary cta-primary-red ml-20">
                      {isEditorActive() ? (
                        <Link field={item?.fields?.['Secondary Link']} />
                      ) : (
                        <Link
                          field={item?.fields?.['Secondary Link']?.value}
                        />
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </LazySection>
  )
}

export default withSitecoreContext()(ColumnCard)
